import React from "react";

const RetailerDashboard = React.lazy(() => import("src/pages/retailer_dashboard/RetailerDashboard"));
const SalesReport = React.lazy(() => import("src/pages/sales_report/SalesReport"));

const routes = [
    { path: "/dashboard/retailer-landing", name: "Dashboard", element: RetailerDashboard },
    { path: "/dashboard/sales-report", name: "Sales Report", element: SalesReport }
];

export default routes;
